import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 10, text: "良品", enum: "GOOD" },
  { value: 20, text: "不良品", enum: "BAD" },
]);
